import React from "react";
import About from "./components/about";
import Skills from "./components/skills";
import Projects from "./components/projects";
import "./App.css";
import Contact from "./components/contact";
import ContactForm from "./components/contact-form";
import Footer from "./components/footer";

const App = () => {
  return (
    <div className="container-fluid wrapper p-0">
      <div className="d-flex h-100 vw-100 text-center text-dark page-body">
        <div className="cover-container d-flex w-100 h-100 p-3 mx-auto flex-column">
          <header className="py-2">
            <div>
              <h3 className="float-md-start mb-0">Mern Stack Developer</h3>
              <nav className="nav nav-masthead justify-content-center float-md-end">
                <a
                  className="nav-link active"
                  aria-current="page"
                  href="#about"
                >
                  About
                </a>
                <a className="nav-link" href="#skills">
                  Skills
                </a>
                <a className="nav-link" href="#projects">
                  Projects
                </a>
                <a className="nav-link" href="#contact">
                  Contact
                </a>
              </nav>
            </div>
          </header>

          <main
            className="px-3 scrollspy-example"
            data-bs-spy="scroll"
            data-bs-target="#navbar-example2"
            data-bs-offset="0"
            tabindex="0"
          >
            <section className="py-5 text-md-start container" id="about">
              <About />
            </section>
            <section className="py-5 text-md-start mt-5 " id="skills">
              <Skills />
            </section>
            <section className="py-5 text-md-start mt-5" id="projects">
              <Projects />
            </section>
            <section className="py-5 text-md-start mt-5" id="contact">
              <ContactForm />
            </section>
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default App;
